module.exports = __webpack_public_path__ + "static/media/ct-logo.1a1e80a1.png";